import i18n from "../language/i18n";

export const retrieveBrandDTOByUserProfileOptionList = (userProfile: any) => {
  const brandDTOOptionList = [];
  if (userProfile) {
    if (userProfile.branchDTOList) {
      for (const branchDTO of userProfile.branchDTOList) {
        const currentBrand =
          branchDTO.gradeDTO.seasonDTO.institutionDTO.campusDTO.brandDTO;
        if (
          brandDTOOptionList.findIndex(
            (brandDTOOption) => brandDTOOption.value === currentBrand.id,
          ) === -1
        ) {
          brandDTOOptionList.push({
            value: currentBrand.id,
            fullValue: currentBrand,
            text: currentBrand.name,
          });
        }
      }
    }
    if (userProfile.gradeDTOList) {
      for (const gradeDTO of userProfile.gradeDTOList) {
        const currentBrand =
          gradeDTO.seasonDTO.institutionDTO.campusDTO.brandDTO;
        if (
          brandDTOOptionList.findIndex(
            (brandDTOOption) => brandDTOOption.value === currentBrand.id,
          ) === -1
        ) {
          brandDTOOptionList.push({
            value: currentBrand.id,
            fullValue: currentBrand,
            text: currentBrand.name,
          });
        }
      }
    }

    if (userProfile.seasonDTOList) {
      for (const seasonDTO of userProfile.seasonDTOList) {
        const currentBrand = seasonDTO.institutionDTO.campusDTO.brandDTO;
        if (
          brandDTOOptionList.findIndex(
            (brandDTOOption) => brandDTOOption.value === currentBrand.id,
          ) === -1
        ) {
          brandDTOOptionList.push({
            value: currentBrand.id,
            fullValue: currentBrand,
            text: currentBrand.name,
          });
        }
      }
    }

    if (userProfile.institutionDTOList) {
      for (const institutionDTO of userProfile.institutionDTOList) {
        const currentBrand = institutionDTO.campusDTO.brandDTO;
        if (
          brandDTOOptionList.findIndex(
            (brandDTOOption) => brandDTOOption.value === currentBrand.id,
          ) === -1
        ) {
          brandDTOOptionList.push({
            value: currentBrand.id,
            fullValue: currentBrand,
            text: currentBrand.name,
          });
        }
      }
    }

    if (userProfile.campusDTOList) {
      for (const campusDTO of userProfile.campusDTOList) {
        const currentBrand = campusDTO.brandDTO;
        if (
          brandDTOOptionList.findIndex(
            (brandDTOOption) => brandDTOOption.value === currentBrand.id,
          ) === -1
        ) {
          brandDTOOptionList.push({
            value: currentBrand.id,
            fullValue: currentBrand,
            text: currentBrand.name,
          });
        }
      }
    }

    if (userProfile.brandDTOList) {
      for (const brandDTO of userProfile.brandDTOList) {
        const currentBrand = brandDTO;
        if (
          brandDTOOptionList.findIndex(
            (brandDTOOption) => brandDTOOption.value === currentBrand.id,
          ) === -1
        ) {
          brandDTOOptionList.push({
            value: currentBrand.id,
            fullValue: currentBrand,
            text: currentBrand.name,
          });
        }
      }
    }
  }

  return brandDTOOptionList;
};

export const retrieveBrandDTOOptionList = (brandDTOList: any) => {
  return brandDTOList.map((brandDTO: any) => ({
    value: brandDTO.id,
    text: brandDTO.name,
    fullValue: brandDTO,
  }));
};

export const retrieveCampusDTOOptionList = (campusDTOList: any) => {
  return campusDTOList
    .map((campusDTO: any) => ({
      value: campusDTO.id,
      text: `${campusDTO.name} (${campusDTO.brandDTO.name})`,
      fullValue: campusDTO,
    }))
    .sort((a: any, b: any) =>
      a.text.localeCompare(b.text, undefined, { numeric: true }),
    );
};

export const retrieveInstitutionDTOOptionList = (institutionDTOList: any) => {
  return institutionDTOList
    .map((institutionDTO: any) => ({
      value: institutionDTO.id,
      text: `${institutionDTO.name} (${institutionDTO.campusDTO.name} - ${institutionDTO.campusDTO.brandDTO.name})`,
      fullValue: institutionDTO,
    }))
    .sort((a: any, b: any) =>
      a.text.localeCompare(b.text, undefined, { numeric: true }),
    );
};

export const retrieveSeasonDTOOptionList = (seasonDTOList: any) => {
  return seasonDTOList
    .map((seasonDTO: any) => ({
      value: seasonDTO.id,
      text: `${seasonDTO.name} (${seasonDTO.institutionDTO.name})`,
      fullValue: seasonDTO,
      // text: `${seasonDTO.name} (${seasonDTO.institutionDTO.name} - ${seasonDTO.institutionDTO.campusDTO.name}/${seasonDTO.institutionDTO.campusDTO.brandDTO.name})`,
    }))
    .sort((a: any, b: any) =>
      a.text.localeCompare(b.text, undefined, { numeric: true }),
    );
};

export const retrieveGradeDTOOptionList = (gradeDTOList: any) => {
  return gradeDTOList
    .map((gradeDTO: any) => ({
      value: gradeDTO.id,
      text: `${gradeDTO.name} (${gradeDTO.seasonDTO.name} - ${gradeDTO.seasonDTO.institutionDTO.name})`,
      fullValue: gradeDTO,
      // text: `${gradeDTO.name} (${gradeDTO.seasonDTO.name} ${gradeDTO.seasonDTO.institutionDTO.name} - ${gradeDTO.seasonDTO.institutionDTO.campusDTO.name}/${gradeDTO.seasonDTO.institutionDTO.campusDTO.brandDTO.name})`,
    }))
    .sort((a: any, b: any) =>
      a.text.localeCompare(b.text, undefined, { numeric: true }),
    );
};

export const retrieveBranchDTOOptionList = (branchDTOList: any) => {
  return branchDTOList
    .map((branchDTO: any) => ({
      value: branchDTO.id,
      text: `${branchDTO.name} (${branchDTO.gradeDTO.name} - ${branchDTO.gradeDTO.seasonDTO.name}/${branchDTO.gradeDTO.seasonDTO.institutionDTO.name})`,
      fullValue: branchDTO,
      // text: `${branchDTO.name} (${branchDTO.gradeDTO.name} - ${branchDTO.gradeDTO.seasonDTO.name}/${branchDTO.gradeDTO.seasonDTO.institutionDTO.name}/${branchDTO.gradeDTO.seasonDTO.institutionDTO.campusDTO.name}/${branchDTO.gradeDTO.seasonDTO.institutionDTO.campusDTO.brandDTO.name})`,
    }))
    .sort((a: any, b: any) =>
      a.text.localeCompare(b.text, undefined, { numeric: true }),
    );
};

export const retrieveCampusDTOByUserProfileOptionList = (
  userProfile: any,
  selectedBrandId: any,
) => {
  const campusDTOOptionList = [];
  if (userProfile) {
    if (selectedBrandId) {
      if (userProfile.branchDTOList) {
        for (const branchDTO of userProfile.branchDTOList) {
          const currentCampus =
            branchDTO.gradeDTO.seasonDTO.institutionDTO.campusDTO;
          if (
            campusDTOOptionList.findIndex(
              (campusDTOOption) => campusDTOOption.value === currentCampus.id,
            ) === -1 &&
            currentCampus.brandDTO.id === parseFloat(selectedBrandId)
          ) {
            campusDTOOptionList.push({
              value: currentCampus.id,
              fullValue: currentCampus,
              text: currentCampus.name,
            });
          }
        }
      }

      if (userProfile.gradeDTOList) {
        for (const gradeDTO of userProfile.gradeDTOList) {
          const currentCampus = gradeDTO.seasonDTO.institutionDTO.campusDTO;
          if (
            campusDTOOptionList.findIndex(
              (campusDTOOption) => campusDTOOption.value === currentCampus.id,
            ) === -1 &&
            currentCampus.brandDTO.id === parseFloat(selectedBrandId)
          ) {
            campusDTOOptionList.push({
              value: currentCampus.id,
              fullValue: currentCampus,
              text: currentCampus.name,
            });
          }
        }
      }

      if (userProfile.seasonDTOList) {
        for (const seasonDTO of userProfile.seasonDTOList) {
          const currentCampus = seasonDTO.institutionDTO.campusDTO;
          if (
            campusDTOOptionList.findIndex(
              (campusDTOOption) => campusDTOOption.value === currentCampus.id,
            ) === -1 &&
            currentCampus.brandDTO.id === parseFloat(selectedBrandId)
          ) {
            campusDTOOptionList.push({
              value: currentCampus.id,
              fullValue: currentCampus,
              text: currentCampus.name,
            });
          }
        }
      }

      if (userProfile.institutionDTOList) {
        for (const institutionDTO of userProfile.institutionDTOList) {
          const currentCampus = institutionDTO.campusDTO;
          if (
            campusDTOOptionList.findIndex(
              (campusDTOOption) => campusDTOOption.value === currentCampus.id,
            ) === -1 &&
            currentCampus.brandDTO.id === parseFloat(selectedBrandId)
          ) {
            campusDTOOptionList.push({
              value: currentCampus.id,
              fullValue: currentCampus,
              text: currentCampus.name,
            });
          }
        }
      }

      if (userProfile.campusDTOList) {
        for (const campusDTO of userProfile.campusDTOList) {
          const currentCampus = campusDTO;
          if (
            campusDTOOptionList.findIndex(
              (campusDTOOption) => campusDTOOption.value === currentCampus.id,
            ) === -1 &&
            currentCampus.brandDTO.id === parseFloat(selectedBrandId)
          ) {
            campusDTOOptionList.push({
              value: currentCampus.id,
              fullValue: currentCampus,
              text: currentCampus.name,
            });
          }
        }
      }

      return campusDTOOptionList;
    }
  }

  return [];
};

export const retrieveInstitutionDTOByUserProfileOptionList = (
  userProfile: any,
  selectedBrandId: any,
  selectedCampusId: any,
) => {
  const institutionDTOOptionList = [];
  if (userProfile) {
    if (selectedCampusId) {
      if (userProfile.branchDTOList) {
        for (const branchDTO of userProfile.branchDTOList) {
          const currentInstitution =
            branchDTO.gradeDTO.seasonDTO.institutionDTO;
          if (
            institutionDTOOptionList.findIndex(
              (institutionDTOOption) =>
                institutionDTOOption.value === currentInstitution.id,
            ) === -1 &&
            currentInstitution.campusDTO.brandDTO.id ===
              parseFloat(selectedBrandId) &&
            currentInstitution.campusDTO.id === parseFloat(selectedCampusId)
          ) {
            institutionDTOOptionList.push({
              value: currentInstitution.id,
              fullValue: currentInstitution,
              text: currentInstitution.name,
            });
          }
        }
      }

      if (userProfile.gradeDTOList) {
        for (const gradeDTO of userProfile.gradeDTOList) {
          const currentInstitution = gradeDTO.seasonDTO.institutionDTO;
          if (
            institutionDTOOptionList.findIndex(
              (institutionDTOOption) =>
                institutionDTOOption.value === currentInstitution.id,
            ) === -1 &&
            currentInstitution.campusDTO.brandDTO.id ===
              parseFloat(selectedBrandId) &&
            currentInstitution.campusDTO.id === parseFloat(selectedCampusId)
          ) {
            institutionDTOOptionList.push({
              value: currentInstitution.id,
              fullValue: currentInstitution,
              text: currentInstitution.name,
            });
          }
        }
      }

      if (userProfile.seasonDTOList) {
        for (const seasonDTO of userProfile.seasonDTOList) {
          const currentInstitution = seasonDTO.institutionDTO;
          if (
            institutionDTOOptionList.findIndex(
              (institutionDTOOption) =>
                institutionDTOOption.value === currentInstitution.id,
            ) === -1 &&
            currentInstitution.campusDTO.brandDTO.id ===
              parseFloat(selectedBrandId) &&
            currentInstitution.campusDTO.id === parseFloat(selectedCampusId)
          ) {
            institutionDTOOptionList.push({
              value: currentInstitution.id,
              fullValue: currentInstitution,
              text: currentInstitution.name,
            });
          }
        }
      }

      if (userProfile.institutionDTOList) {
        for (const institutionDTO of userProfile.institutionDTOList) {
          const currentInstitution = institutionDTO;
          if (
            institutionDTOOptionList.findIndex(
              (institutionDTOOption) =>
                institutionDTOOption.value === currentInstitution.id,
            ) === -1 &&
            currentInstitution.campusDTO.brandDTO.id ===
              parseFloat(selectedBrandId) &&
            currentInstitution.campusDTO.id === parseFloat(selectedCampusId)
          ) {
            institutionDTOOptionList.push({
              value: currentInstitution.id,
              fullValue: currentInstitution,
              text: currentInstitution.name,
            });
          }
        }
      }
    }
  }
  return institutionDTOOptionList;
};

export const retrieveSeasonDTOByUserProfileOptionList = (
  userProfile: any,
  selectedBrandId: any,
  selectedInstitutionId: any,
) => {
  const seasonDTOOptionList = [];
  if (userProfile) {
    if (selectedInstitutionId) {
      if (userProfile.branchDTOList) {
        for (const branchDTO of userProfile.branchDTOList) {
          const currentSeason = branchDTO.gradeDTO.seasonDTO;
          if (
            seasonDTOOptionList.findIndex(
              (seasonDTOOption) => seasonDTOOption.value === currentSeason.id,
            ) === -1 &&
            currentSeason.institutionDTO.campusDTO.brandDTO.id ===
              parseFloat(selectedBrandId) &&
            currentSeason.institutionDTO.id ===
              parseFloat(selectedInstitutionId)
          ) {
            seasonDTOOptionList.push({
              value: currentSeason.id,
              fullValue: currentSeason,
              text: currentSeason.name,
            });
          }
        }
      }

      if (userProfile.gradeDTOList) {
        for (const gradeDTO of userProfile.gradeDTOList) {
          const currentSeason = gradeDTO.seasonDTO;
          if (
            seasonDTOOptionList.findIndex(
              (seasonDTOOption) => seasonDTOOption.value === currentSeason.id,
            ) === -1 &&
            currentSeason.institutionDTO.campusDTO.brandDTO.id ===
              parseFloat(selectedBrandId) &&
            currentSeason.institutionDTO.id ===
              parseFloat(selectedInstitutionId)
          ) {
            seasonDTOOptionList.push({
              value: currentSeason.id,
              fullValue: currentSeason,
              text: currentSeason.name,
            });
          }
        }
      }

      if (userProfile.seasonDTOList) {
        for (const seasonDTO of userProfile.seasonDTOList) {
          const currentSeason = seasonDTO;
          if (
            seasonDTOOptionList.findIndex(
              (seasonDTOOption) => seasonDTOOption.value === currentSeason.id,
            ) === -1 &&
            currentSeason.institutionDTO.campusDTO.brandDTO.id ===
              parseFloat(selectedBrandId) &&
            currentSeason.institutionDTO.id ===
              parseFloat(selectedInstitutionId)
          ) {
            seasonDTOOptionList.push({
              value: currentSeason.id,
              fullValue: currentSeason,
              text: currentSeason.name,
            });
          }
        }
      }
    }
  }
  return seasonDTOOptionList;
};

export const retrieveGradeDTOByUserProfileOptionList = (
  userProfile: any,
  selectedBrandId: any,
  selectedSeasonId: any,
) => {
  const gradeDTOOptionList = [];
  if (userProfile) {
    if (selectedSeasonId) {
      if (userProfile.branchDTOList) {
        for (const branchDTO of userProfile.branchDTOList) {
          const currentGrade = branchDTO.gradeDTO;
          if (
            gradeDTOOptionList.findIndex(
              (gradeDTOOption) => gradeDTOOption.value === currentGrade.id,
            ) === -1 &&
            currentGrade.seasonDTO.institutionDTO.campusDTO.brandDTO.id ===
              parseFloat(selectedBrandId) &&
            currentGrade.seasonDTO.id === parseFloat(selectedSeasonId)
          ) {
            gradeDTOOptionList.push({
              value: currentGrade.id,
              fullValue: currentGrade,
              text: currentGrade.name,
            });
          }
        }
      }

      if (userProfile.gradeDTOList) {
        for (const gradeDTO of userProfile.gradeDTOList) {
          const currentGrade = gradeDTO;
          if (
            gradeDTOOptionList.findIndex(
              (gradeDTOOption) => gradeDTOOption.value === currentGrade.id,
            ) === -1 &&
            currentGrade.seasonDTO.institutionDTO.campusDTO.brandDTO.id ===
              parseFloat(selectedBrandId) &&
            currentGrade.seasonDTO.id === parseFloat(selectedSeasonId)
          ) {
            gradeDTOOptionList.push({
              value: currentGrade.id,
              fullValue: currentGrade,
              text: currentGrade.name,
            });
          }
        }
      }
    }
  }
  return gradeDTOOptionList;
};

export const retrieveBranchDTOByUserProfileOptionList = (
  userProfile: any,
  selectedBrandId: any,
  selectedGradeId: any,
) => {
  const branchDTOOptionList = [];
  if (userProfile) {
    if (selectedGradeId) {
      if (userProfile.branchDTOList) {
        for (const branchDTO of userProfile.branchDTOList) {
          const currentBranch = branchDTO;
          if (
            branchDTOOptionList.findIndex(
              (branchDTOOption) => branchDTOOption.value === currentBranch.id,
            ) === -1 &&
            currentBranch.gradeDTO.seasonDTO.institutionDTO.campusDTO.brandDTO
              .id === parseFloat(selectedBrandId) &&
            currentBranch.gradeDTO.id === parseFloat(selectedGradeId)
          ) {
            branchDTOOptionList.push({
              value: currentBranch.id,
              fullValue: currentBranch,
              text: currentBranch.name,
            });
          }
        }
      }
    }
  }
  return branchDTOOptionList;
};

export const retrieveExternalRegistrationDTOOptionList = (
  externalRegistrationDTOList: any,
) => {
  return externalRegistrationDTOList.map((externalRegistrationDTO: any) => ({
    value: externalRegistrationDTO.id,
    text: externalRegistrationDTO.name,
    fullValue: externalRegistrationDTO,
    // text: `${seasonDTO.name} (${seasonDTO.institutionDTO.name} - ${seasonDTO.institutionDTO.campusDTO.name}/${seasonDTO.institutionDTO.campusDTO.brandDTO.name})`,
  }));
};

export const retrieveGenderOptionList = () => {
  return [
    {
      value: "MALE",
      text: i18n.t("MALE"),
    },
    {
      value: "FEMALE",
      text: i18n.t("FEMALE"),
    },
    {
      value: "NOT_GIVEN",
      text: i18n.t("NOT_GIVEN"),
    },
  ];
};

export const retrieveEnableOptionList = () => {
  return [
    {
      value: true,
      text: i18n.t("yes"),
    },
    {
      value: false,
      text: i18n.t("no"),
    },
  ];
};

export const retrieveUserRoleOptionList = () => {
  return [
    {
      value: "STAFF",
      text: i18n.t("STAFF"),
    },
    {
      value: "LEARNER",
      text: i18n.t("LEARNER"),
    },
    {
      value: "PARENT",
      text: i18n.t("PARENT"),
    },
    {
      value: "CONTENT_CREATOR",
      text: i18n.t("CONTENT_CREATOR"),
    },
  ];
};

export const filterUserRoleOptionList = (
  accountType: any,
  userProfileRole: any,
) => {
  if (accountType === "GENIXO") {
    return retrieveUserRoleOptionList().filter(
      (userRoleOption) =>
        userRoleOption.value === "STAFF" ||
        userRoleOption.value === "LEARNER" ||
        userRoleOption.value === "CONTENT_CREATOR",
    );
  } else {
    if (userProfileRole === "STAFF") {
      return retrieveUserRoleOptionList().filter(
        (userRoleOption) =>
          userRoleOption.value === "STAFF" ||
          userRoleOption.value === "LEARNER" ||
          userRoleOption.value === "CONTENT_CREATOR",
      );
    }
  }

  return [];
};

export const retrieveDefaultUserRoleOptionList = () => {
  return [
    {
      value: "BASIC",
      text: i18n.t("BASIC"),
    },
    {
      value: "LEARNER",
      text: i18n.t("LEARNER"),
    },
    {
      value: "STAFF_WRITER",
      text: i18n.t("STAFF_WRITER"),
    },
    {
      value: "STAFF_TEACHER",
      text: i18n.t("STAFF_TEACHER"),
    },
    {
      value: "STAFF_COTERIE_MANAGER",
      text: i18n.t("STAFF_COTERIE_MANAGER"),
    },
    {
      value: "STAFF_INSTITUTION_MANAGER",
      text: i18n.t("STAFF_INSTITUTION_MANAGER"),
    },
    {
      value: "STAFF_INSTITUTION_ASSISTANT_MANAGER",
      text: i18n.t("STAFF_INSTITUTION_ASSISTANT_MANAGER"),
    },
    {
      value: "STAFF_CAMPUS_MANAGER",
      text: i18n.t("STAFF_CAMPUS_MANAGER"),
    },
    {
      value: "STAFF_BRAND_MANAGER",
      text: i18n.t("STAFF_BRAND_MANAGER"),
    },
    {
      value: "STAFF_INFORMATION_TECHNOLOGY",
      text: i18n.t("STAFF_INFORMATION_TECHNOLOGY"),
    },
    {
      value: "CONTENT_CREATOR",
      text: i18n.t("CONTENT_CREATOR"),
    },
  ];
};

export const retrieveCountryCodeOptionList = () => {
  return [
    {
      value: "TR",
      text: i18n.t("TR"),
      parent: "TURKEY",
    },
    // {
    //   value: "US",
    //   text: i18n.t("US"),
    //   parent: "UNITED_STATES",
    // },
    // {
    //   value: "DE",
    //   text: i18n.t("DE"),
    //   parent: "GERMANY",
    // },
  ];
};

export const retrieveCountryNameOptionList = () => {
  return [
    {
      value: "TURKEY",
      text: i18n.t("TURKEY"),
    },
    // {
    //   value: "UNITED_STATES",
    //   text: i18n.t("UNITED_STATES"),
    // },
    // {
    //   value: "GERMANY",
    //   text: i18n.t("GERMANY"),
    // },
  ];
};

export const retrieveProvinceNameOptionList = () => {
  return [
    { parent: "TURKEY", value: "ADANA", text: "Adana", code: "01" },
    // { parent: "TURKEY", value: "ADIYAMAN", text: "Adıyaman", code: "02" },
    { parent: "TURKEY", value: "AFYON", text: "Afyon", code: "03" },
    // { parent: "TURKEY", value: "AGRI", text: "Ağrı", code: "04" },
    // { parent: "TURKEY", value: "AMASYA", text: "Amasya", code: "05" },
    { parent: "TURKEY", value: "ANKARA", text: "Ankara", code: "06" },
    { parent: "TURKEY", value: "ANTALYA", text: "Antalya", code: "07" },
    // { parent: "TURKEY", value: "ARTVIN", text: "Artvin", code: "08" },
    { parent: "TURKEY", value: "AYDIN", text: "Aydın", code: "09" },
    { parent: "TURKEY", value: "BALIKESIR", text: "Balıkesir", code: "10" },
    // { parent: "TURKEY", value: "BILECIK", text: "Bilecik", code: "11" },
    // { parent: "TURKEY", value: "BINGOL", text: "Bingöl", code: "12" },
    // { parent: "TURKEY", value: "BITLIS", text: "Bitlis", code: "13" },
    // { parent: "TURKEY", value: "BOLU", text: "Bolu", code: "14" },
    // { parent: "TURKEY", value: "BURDUR", text: "Burdur", code: "15" },
    { parent: "TURKEY", value: "BURSA", text: "Bursa", code: "16" },
    { parent: "TURKEY", value: "CANAKKALE", text: "Çanakkale", code: "17" },
    // { parent: "TURKEY", value: "CANKIRI", text: "Çankırı", code: "18" },
    { parent: "TURKEY", value: "CORUM", text: "Çorum", code: "19" },
    { parent: "TURKEY", value: "DENIZLI", text: "Denizli", code: "20" },
    { parent: "TURKEY", value: "DIYARBAKIR", text: "Diyarbakır", code: "21" },
    // { parent: "TURKEY", value: "EDIRNE", text: "Edirne", code: "22" },
    // { parent: "TURKEY", value: "ELAZIG", text: "Elazığ", code: "23" },
    // { parent: "TURKEY", value: "ERZINCAN", text: "Erzincan", code: "24" },
    // { parent: "TURKEY", value: "ERZURUM", text: "Erzurum", code: "25" },
    { parent: "TURKEY", value: "ESKISEHIR", text: "Eskişehir", code: "26" },
    { parent: "TURKEY", value: "GAZIANTEP", text: "Gaziantep", code: "27" },
    // { parent: "TURKEY", value: "GIRESUN", text: "Giresun", code: "28" },
    // { parent: "TURKEY", value: "GUMUSHANE", text: "Gümüşhane", code: "29" },
    // { parent: "TURKEY", value: "HAKKARI", text: "Hakkari", code: "30" },
    { parent: "TURKEY", value: "HATAY", text: "Hatay", code: "31" },
    // { parent: "TURKEY", value: "ISPARTA", text: "Isparta", code: "32" },
    { parent: "TURKEY", value: "MERSIN", text: "Mersin", code: "33" },
    { parent: "TURKEY", value: "ISTANBUL", text: "İstanbul", code: "34" },
    { parent: "TURKEY", value: "IZMIR", text: "İzmir", code: "35" },
    // { parent: "TURKEY", value: "KARS", text: "Kars", code: "36" },
    // { parent: "TURKEY", value: "KASTAMONU", text: "Kastamonu", code: "37" },
    { parent: "TURKEY", value: "KAYSERI", text: "Kayseri", code: "38" },
    { parent: "TURKEY", value: "KIRKLARELI", text: "Kırklareli", code: "39" },
    // { parent: "TURKEY", value: "KIRSEHIR", text: "Kırşehir", code: "40" },
    { parent: "TURKEY", value: "KOCAELI", text: "Kocaeli", code: "41" },
    // { parent: "TURKEY", value: "KONYA", text: "Konya", code: "42" },
    // { parent: "TURKEY", value: "KUTAHYA", text: "Kütahya", code: "43" },
    // { parent: "TURKEY", value: "MALATYA", text: "Malatya", code: "44" },
    // { parent: "TURKEY", value: "MANISA", text: "Manisa", code: "45" },
    // {
    //   parent: "TURKEY",
    //   value: "KAHRAMANMARAS",
    //   text: "Kahramanmaraş",
    //   code: "46",
    // },
    { parent: "TURKEY", value: "MARDIN", text: "Mardin", code: "47" },
    // { parent: "TURKEY", value: "MUGLA", text: "Muğla", code: "48" },
    // { parent: "TURKEY", value: "MUS", text: "Muş", code: "49" },
    // { parent: "TURKEY", value: "NEVSEHIR", text: "Nevşehir", code: "50" },
    // { parent: "TURKEY", value: "NIGDE", text: "Niğde", code: "51" },
    // { parent: "TURKEY", value: "ORDU", text: "Ordu", code: "52" },
    // { parent: "TURKEY", value: "RIZE", text: "Rize", code: "53" },
    // { parent: "TURKEY", value: "SAKARYA", text: "Sakarya", code: "54" },
    { parent: "TURKEY", value: "SAMSUN", text: "Samsun", code: "55" },
    // { parent: "TURKEY", value: "SIIRT", text: "Siirt", code: "56" },
    // { parent: "TURKEY", value: "SINOP", text: "Sinop", code: "57" },
    // { parent: "TURKEY", value: "SIVAS", text: "Sivas", code: "58" },
    // { parent: "TURKEY", value: "TEKIRDAG", text: "Tekirdağ", code: "59" },
    // { parent: "TURKEY", value: "TOKAT", text: "Tokat", code: "60" },
    // { parent: "TURKEY", value: "TRABZON", text: "Trabzon", code: "61" },
    // { parent: "TURKEY", value: "TUNCELI", text: "Tunceli", code: "62" },
    // { parent: "TURKEY", value: "SANLIURFA", text: "Şanlıurfa", code: "63" },
    // { parent: "TURKEY", value: "USAK", text: "Uşak", code: "64" },
    // { parent: "TURKEY", value: "VAN", text: "Van", code: "65" },
    // { parent: "TURKEY", value: "YOZGAT", text: "Yozgat", code: "66" },
    // { parent: "TURKEY", value: "ZONGULDAK", text: "Zonguldak", code: "67" },
    // { parent: "TURKEY", value: "AKSARAY", text: "Aksaray", code: "68" },
    // { parent: "TURKEY", value: "BAYBURT", text: "Bayburt", code: "69" },
    // { parent: "TURKEY", value: "KARAMAN", text: "Karaman", code: "70" },
    // { parent: "TURKEY", value: "KIRIKKALE", text: "Kırıkkale", code: "71" },
    // { parent: "TURKEY", value: "BATMAN", text: "Batman", code: "72" },
    // { parent: "TURKEY", value: "SIRNAK", text: "Şırnak", code: "73" },
    // { parent: "TURKEY", value: "BARTIN", text: "Bartın", code: "74" },
    // { parent: "TURKEY", value: "ARDAHAN", text: "Ardahan", code: "75" },
    // { parent: "TURKEY", value: "IGDIR", text: "Iğdır", code: "76" },
    // { parent: "TURKEY", value: "YALOVA", text: "Yalova", code: "77" },
    // { parent: "TURKEY", value: "KARABUK", text: "Karabük", code: "78" },
    // { parent: "TURKEY", value: "KILIS", text: "Kilis", code: "79" },
    { parent: "TURKEY", value: "OSMANIYE", text: "Osmaniye", code: "80" },
    { parent: "TURKEY", value: "DUZCE", text: "Düzce", code: "81" },
  ];
};

export const retrievePhoneNumberAreaCodeList = () => {
  return [
    {
      parent: "UNITED_STATES",
      value: "+1",
      text: "+1",
    },
    {
      parent: "GERMANY",
      value: "+49",
      text: "+49",
    },
    {
      parent: "TURKEY",
      value: "+90",
      text: "+90",
    },
  ];
};

export const retrieveInstitutionTypeOptionList = () => {
  return [
    {
      value: "WEST_PRIMARY",
      text: i18n.t("WEST_PRIMARY"),
    },
    {
      value: "EAST_PRIMARY",
      text: i18n.t("EAST_PRIMARY"),
    },
    {
      value: "EAST_SECONDARY",
      text: i18n.t("EAST_SECONDARY"),
    },
    {
      value: "HIGH_SCHOOL",
      text: i18n.t("HIGH_SCHOOL"),
    },
    {
      value: "PRIVATE_TRAINING",
      text: i18n.t("PRIVATE_TRAINING"),
    },
    {
      value: "PRIVATE_LESSON",
      text: i18n.t("PRIVATE_LESSON"),
    },
    {
      value: "COURSE",
      text: i18n.t("COURSE"),
    },
    {
      value: "COMPANY",
      text: i18n.t("COMPANY"),
    },
    {
      value: "ORGANIZATION",
      text: i18n.t("ORGANIZATION"),
    },
  ];
};

export const retrieveGradeLevelOptionList = () => {
  return [
    {
      value: 0,
      text: i18n.t("other"),
    },
    {
      value: 1,
      text: i18n.t("1"),
    },
    {
      value: 2,
      text: i18n.t("2"),
    },
    {
      value: 3,
      text: i18n.t("3"),
    },
    {
      value: 4,
      text: i18n.t("4"),
    },
    {
      value: 5,
      text: i18n.t("5"),
    },
    {
      value: 6,
      text: i18n.t("6"),
    },
    {
      value: 7,
      text: i18n.t("7"),
    },
    {
      value: 8,
      text: i18n.t("8"),
    },
    {
      value: 9,
      text: i18n.t("9"),
    },
    {
      value: 10,
      text: i18n.t("10"),
    },
    {
      value: 11,
      text: i18n.t("11"),
    },
    {
      value: 12,
      text: i18n.t("12"),
    },
  ];
};

export const constructUserProfileQueryParams = (
  userProfile: any,
  userProfileBrand: any,
) => {
  let queryParams: any;
  if (userProfile.branchDTOList.length > 0) {
    queryParams = {
      ...queryParams,
      branchIdList: userProfile.branchDTOList.map(
        (branchDTO: any) => branchDTO.id,
      ),
    };
  } else if (userProfile.gradeDTOList.length > 0) {
    queryParams = {
      ...queryParams,
      gradeIdList: userProfile.gradeDTOList.map((gradeDTO: any) => gradeDTO.id),
    };
  } else if (userProfile.seasonDTOList.length > 0) {
    queryParams = {
      ...queryParams,
      seasonIdList: userProfile.seasonDTOList.map(
        (seasonDTO: any) => seasonDTO.id,
      ),
    };
  } else if (userProfile.institutionDTOList.length > 0) {
    queryParams = {
      ...queryParams,
      institutionIdList: userProfile.institutionDTOList.map(
        (institutionDTO: any) => institutionDTO.id,
      ),
    };
  } else if (userProfile.campusDTOList.length > 0) {
    queryParams = {
      ...queryParams,
      campusIdList: userProfile.campusDTOList.map(
        (campusDTO: any) => campusDTO.id,
      ),
    };
  } else if (userProfile.brandDTOList.length > 0) {
    queryParams = {
      ...queryParams,
      brandIdList: [userProfileBrand.id],
    };
  }
  queryParams.deleted = false;
  return queryParams;
};

export const retrieveCoterieTypeOptionList = () => {
  return [
    {
      text: i18n.t("MANAGEMENT"),
      value: "MANAGEMENT",
      includes: [
        "WEST_PRIMARY",
        "EAST_PRIMARY",
        "EAST_SECONDARY",
        "COLLEGE",
        "HIGH_SCHOOL",
        "COURSE",
        "PRIVATE_TRAINING",
        "PRIVATE_LESSON",
        "COMPANY",
        "ORGANIZATION",
      ],
    },
    {
      // Türkçe is a 1-8 subject; at lise it becomes Türk Dili ve Edebiyatı (LITERATURE).
      text: i18n.t("TURKISH"),
      value: "TURKISH",
      includes: [
        "WEST_PRIMARY",
        "EAST_PRIMARY",
        "EAST_SECONDARY",
        "COLLEGE",
        "COURSE",
        "PRIVATE_TRAINING",
        "PRIVATE_LESSON",
        "COMPANY",
        "ORGANIZATION",
      ],
    },
    {
      text: i18n.t("HISTORY"),
      value: "HISTORY",
      includes: [
        "COLLEGE",
        "HIGH_SCHOOL",
        "COURSE",
        "PRIVATE_TRAINING",
        "PRIVATE_LESSON",
        "COMPANY",
        "ORGANIZATION",
      ],
    },
    {
      text: i18n.t("MATHEMATICS"),
      value: "MATHEMATICS",
      includes: [
        "WEST_PRIMARY",
        "EAST_PRIMARY",
        "EAST_SECONDARY",
        "COLLEGE",
        "HIGH_SCHOOL",
        "COURSE",
        "PRIVATE_TRAINING",
        "PRIVATE_LESSON",
        "COMPANY",
        "ORGANIZATION",
      ],
    },
    {
      text: i18n.t("BIOLOGY"),
      value: "BIOLOGY",
      includes: [
        "COLLEGE",
        "HIGH_SCHOOL",
        "COURSE",
        "PRIVATE_TRAINING",
        "PRIVATE_LESSON",
        "COMPANY",
        "ORGANIZATION",
      ],
    },
    {
      text: i18n.t("LITERATURE"),
      value: "LITERATURE",
      includes: [
        "COLLEGE",
        "HIGH_SCHOOL",
        "COURSE",
        "PRIVATE_TRAINING",
        "PRIVATE_LESSON",
        "COMPANY",
        "ORGANIZATION",
      ],
    },
    {
      text: i18n.t("GEOGRAPHY"),
      value: "GEOGRAPHY",
      includes: [
        "COLLEGE",
        "HIGH_SCHOOL",
        "COURSE",
        "PRIVATE_TRAINING",
        "PRIVATE_LESSON",
        "COMPANY",
        "ORGANIZATION",
      ],
    },
    {
      text: i18n.t("ENGLISH"),
      value: "ENGLISH",
      includes: [
        "WEST_PRIMARY",
        "EAST_PRIMARY",
        "EAST_SECONDARY",
        "COLLEGE",
        "HIGH_SCHOOL",
        "COURSE",
        "PRIVATE_TRAINING",
        "PRIVATE_LESSON",
        "COMPANY",
        "ORGANIZATION",
      ],
    },
    {
      // German-as-foreign-language can be taught at any level, so mirror ENGLISH's
      // institution-type list. Makes the GERMAN coterie selectable in OutcomePicker
      // (non-IB path), which is what surfaces the CEFR-DE-* version codes.
      text: i18n.t("GERMAN"),
      value: "GERMAN",
      includes: [
        "WEST_PRIMARY",
        "EAST_PRIMARY",
        "EAST_SECONDARY",
        "COLLEGE",
        "HIGH_SCHOOL",
        "COURSE",
        "PRIVATE_TRAINING",
        "PRIVATE_LESSON",
        "COMPANY",
        "ORGANIZATION",
      ],
    },
    {
      // French-as-foreign-language, same shape as GERMAN. Makes the FRENCH coterie
      // selectable in OutcomePicker (non-IB path), which is what surfaces the
      // SPE-FRA-* version codes. Offering it here does not grant it: the backend
      // CoterieEligibilityDefaults keeps FRENCH out of every institution type's
      // defaults and a school opts in per season.
      text: i18n.t("FRENCH"),
      value: "FRENCH",
      includes: [
        "WEST_PRIMARY",
        "EAST_PRIMARY",
        "EAST_SECONDARY",
        "COLLEGE",
        "HIGH_SCHOOL",
        "COURSE",
        "PRIVATE_TRAINING",
        "PRIVATE_LESSON",
        "COMPANY",
        "ORGANIZATION",
      ],
    },
    {
      // ZAFER X: Zafer's own AI course (grades 5-12, by level). Same contract as FRENCH:
      // offering it does not grant it — Zafer opens it per season.
      text: i18n.t("ZAFER_X"),
      value: "ZAFER_X",
      includes: [
        "EAST_SECONDARY",
        "COLLEGE",
        "HIGH_SCHOOL",
        "COURSE",
        "PRIVATE_TRAINING",
        "PRIVATE_LESSON",
        "COMPANY",
        "ORGANIZATION",
      ],
    },
    {
      text: i18n.t("PHYSICS"),
      value: "PHYSICS",
      includes: [
        "COLLEGE",
        "HIGH_SCHOOL",
        "COURSE",
        "PRIVATE_TRAINING",
        "PRIVATE_LESSON",
        "COMPANY",
        "ORGANIZATION",
      ],
    },
    {
      text: i18n.t("CHEMISTRY"),
      value: "CHEMISTRY",
      includes: [
        "COLLEGE",
        "HIGH_SCHOOL",
        "COURSE",
        "PRIVATE_TRAINING",
        "PRIVATE_LESSON",
        "COMPANY",
        "ORGANIZATION",
      ],
    },
    {
      text: i18n.t("PHILOSOPHY"),
      value: "PHILOSOPHY",
      includes: [
        "COLLEGE",
        "HIGH_SCHOOL",
        "COURSE",
        "PRIVATE_TRAINING",
        "PRIVATE_LESSON",
        "COMPANY",
        "ORGANIZATION",
      ],
    },
    {
      // Beden Eğitimi, Sanat, Yabancı Dil and Trafik Güvenliği are not offered at K-12
      // levels for now — only the non-K12 (Kolej/Kurs/private/corporate) types.
      text: i18n.t("PHYSICAL_EDUCATION"),
      value: "PHYSICAL_EDUCATION",
      includes: [
        "COLLEGE",
        "COURSE",
        "PRIVATE_TRAINING",
        "PRIVATE_LESSON",
        "COMPANY",
        "ORGANIZATION",
      ],
    },
    {
      text: i18n.t("SOCIAL_STUDIES"),
      value: "SOCIAL_STUDIES",
      includes: [
        "WEST_PRIMARY",
        "EAST_PRIMARY",
        "EAST_SECONDARY",
        "COLLEGE",
        "COURSE",
        "PRIVATE_TRAINING",
        "PRIVATE_LESSON",
        "COMPANY",
        "ORGANIZATION",
      ],
    },
    {
      text: i18n.t("SCIENCE"),
      value: "SCIENCE",
      includes: [
        "WEST_PRIMARY",
        "EAST_PRIMARY",
        "EAST_SECONDARY",
        "COLLEGE",
        "COURSE",
        "PRIVATE_TRAINING",
        "PRIVATE_LESSON",
        "COMPANY",
        "ORGANIZATION",
      ],
    },
    {
      text: i18n.t("LIFE_STUDIES"),
      value: "LIFE_STUDIES",
      includes: [
        "WEST_PRIMARY",
        "EAST_PRIMARY",
        "COLLEGE",
        "COURSE",
        "PRIVATE_TRAINING",
        "PRIVATE_LESSON",
        "COMPANY",
        "ORGANIZATION",
      ],
    },
    {
      text: i18n.t("CULTURE_AND_RELIGION_KNOWLEDGE"),
      value: "CULTURE_AND_RELIGION_KNOWLEDGE",
      includes: [
        "WEST_PRIMARY",
        "EAST_PRIMARY",
        "EAST_SECONDARY",
        "COLLEGE",
        "HIGH_SCHOOL",
        "COURSE",
        "PRIVATE_TRAINING",
        "PRIVATE_LESSON",
        "COMPANY",
        "ORGANIZATION",
      ],
    },
    {
      text: i18n.t("TRAFFIC_SAFETY"),
      value: "TRAFFIC_SAFETY",
      includes: [
        "COLLEGE",
        "COURSE",
        "PRIVATE_TRAINING",
        "PRIVATE_LESSON",
        "COMPANY",
        "ORGANIZATION",
      ],
    },
    {
      // GENERAL_CULTURE is contest-only (gamification) — not an academic coterie for any
      // institution. Kept in the list (achievements/contests reference it directly) but eligible for none.
      text: i18n.t("GENERAL_CULTURE"),
      value: "GENERAL_CULTURE",
      includes: [],
    },
    {
      text: i18n.t("ARTS"),
      value: "ARTS",
      includes: [
        "COLLEGE",
        "COURSE",
        "PRIVATE_TRAINING",
        "PRIVATE_LESSON",
        "COMPANY",
        "ORGANIZATION",
      ],
    },
    {
      // Bilişim Teknolojileri and Tasarım are non-K12-only for now (removed from school levels).
      text: i18n.t("INFORMATION_TECHNOLOGY"),
      value: "INFORMATION_TECHNOLOGY",
      includes: [
        "COLLEGE",
        "COURSE",
        "PRIVATE_TRAINING",
        "PRIVATE_LESSON",
        "COMPANY",
        "ORGANIZATION",
      ],
    },
    {
      text: i18n.t("DESIGN"),
      value: "DESIGN",
      includes: [
        "COLLEGE",
        "COURSE",
        "PRIVATE_TRAINING",
        "PRIVATE_LESSON",
        "COMPANY",
        "ORGANIZATION",
      ],
    },
    {
      text: i18n.t("FOREIGN_LANGUAGE"),
      value: "FOREIGN_LANGUAGE",
      includes: [
        "COLLEGE",
        "COURSE",
        "PRIVATE_TRAINING",
        "PRIVATE_LESSON",
        "COMPANY",
        "ORGANIZATION",
      ],
    },
  ];
};

export const retrieveUserAuthorityGeneralOptionList = () => {
  return [
    { text: i18n.t("all"), value: "" },
    { text: i18n.t("user"), value: "USER" },
    { text: i18n.t("activity"), value: "ACTIVITY" },
    { text: i18n.t("corporate_personalized_assignment"), value: "CATCHTIVITY" },
    { text: i18n.t("corporate_assessment_assignment"), value: "CATCHXAM" },
    { text: i18n.t("label"), value: "LABEL" },
    { text: i18n.t("announcement"), value: "NOTIFICATION" },
    { text: i18n.t("report"), value: "REPORT" },
    { text: i18n.t("category"), value: "CATEGORY" },
    { text: i18n.t("library"), value: "STORAGE_FILE" },
    { text: i18n.t("brand"), value: "BRAND" },
    { text: i18n.t("region"), value: "REGION" },
    { text: i18n.t("campus"), value: "CAMPUS" },
    { text: i18n.t("institution"), value: "INSTITUTION" },
    { text: i18n.t("season"), value: "SEASON" },
    { text: i18n.t("grade"), value: "GRADE" },
    { text: i18n.t("branch"), value: "BRANCH" },
    { text: i18n.t("plan"), value: "PLAN" },
    { text: i18n.t("standard_exam"), value: "STANDARD_EXAM" },
    { text: i18n.t("support_assignment"), value: "SUPPORT_ASSIGNMENT" },
  ];
};

export const filterGradeLevelOptionList = (
  level: any,
  institutionType: any,
) => {
  if (level) {
    return retrieveGradeLevelOptionList().filter(
      (gradeLevel: any) => parseFloat(gradeLevel.value) === level,
    );
  }
  if (institutionType) {
    if (institutionType === "WEST_PRIMARY") {
      return retrieveGradeLevelOptionList().filter(
        (gradeLevel: any) => parseFloat(gradeLevel.value) <= 8,
      );
    } else if (institutionType === "EAST_PRIMARY") {
      return retrieveGradeLevelOptionList().filter(
        (gradeLevel: any) => parseFloat(gradeLevel.value) <= 4,
      );
    } else if (institutionType === "EAST_SECONDARY") {
      return retrieveGradeLevelOptionList().filter(
        (gradeLevel: any) =>
          parseFloat(gradeLevel.value) > 4 && parseFloat(gradeLevel.value) <= 8,
      );
    } else if (institutionType === "HIGH_SCHOOL") {
      return retrieveGradeLevelOptionList().filter(
        (gradeLevel: any) => parseFloat(gradeLevel.value) > 8,
      );
    } else if (
      institutionType === "COLLEGE" ||
      institutionType === "PRIVATE_TRAINING" ||
      institutionType === "PRIVATE_LESSON" ||
      institutionType === "COURSE"
    ) {
      return retrieveGradeLevelOptionList();
    } else {
      return [];
    }
  }
  return retrieveGradeLevelOptionList();
};

export const filterCoterieTypeOptionList = (
  coterieType: any,
  institutionType: any,
  eligibleCoterieTypeList?: any[],
) => {
  if (coterieType === "MANAGEMENT") {
    // Prefer the institution's backend-provided eligible set — it already encodes
    // any per-institution add/remove overrides. Fall back to the static
    // institution-type matrix when it isn't available.
    if (eligibleCoterieTypeList && eligibleCoterieTypeList.length > 0) {
      return retrieveCoterieTypeOptionList()
        .filter((coterieTypeOption) =>
          eligibleCoterieTypeList.includes(coterieTypeOption.value),
        )
        .sort((a, b) => a.text.localeCompare(b.text));
    }
    if (institutionType) {
      return retrieveCoterieTypeOptionList()
        .filter((coterieTypeOption) =>
          coterieTypeOption.includes.includes(institutionType),
        )
        .sort((a, b) => a.text.localeCompare(b.text));
    } else {
      return retrieveCoterieTypeOptionList().sort((a, b) =>
        a.text.localeCompare(b.text),
      );
    }
  } else {
    return retrieveCoterieTypeOptionList()
      .filter((coterieTypeOption) => coterieTypeOption.value === coterieType)
      .sort((a, b) => a.text.localeCompare(b.text));
  }
};

/**
 * The coteries (subjects) the learner's agreement covers.
 *
 * An agreement is negotiated per SEASON — the same institution can cover a
 * subject one year and not the next — so the season's set decides whenever it has
 * one. The institution is kept as a fallback for two cases that both matter: a
 * profile with no season resolved yet, and a backend that has not shipped the
 * season field (the field is served alongside the institution one for a release).
 *
 * An absent list means "not configured", never "nothing is eligible" — every
 * caller treats an empty result as "do not restrict", so this must not manufacture
 * an empty list where the payload simply had none.
 */
export const resolveEligibleCoterieTypeList = (
  userProfileSeason?: any,
  userProfileInstitution?: any,
) =>
  userProfileSeason?.eligibleCoterieTypeList ??
  userProfileInstitution?.eligibleCoterieTypeList;

export const filterCoterieTypeByDistinctOptionList = (
  distinctCoterieTypeOptionList: any[],
  eligibleCoterieTypeList?: any[],
) => {
  let coterieTypeOptionList = retrieveCoterieTypeOptionList();
  // The institution's eligible set bounds which coteries are even considered; the
  // distinct (plan/assignment/performance) list then narrows to what the learner has.
  // Guard: when no eligible list is provided, fall back to the full universe.
  if (eligibleCoterieTypeList && eligibleCoterieTypeList.length > 0) {
    coterieTypeOptionList = coterieTypeOptionList.filter((item) =>
      eligibleCoterieTypeList.includes(item.value),
    );
  }
  const filteredCoterieTypeOptionList = coterieTypeOptionList.filter((item) =>
    distinctCoterieTypeOptionList.includes(item.value),
  );
  return filteredCoterieTypeOptionList.sort((a, b) =>
    a.text.localeCompare(b.text),
  );
};

export const findAISettingsFromCurrentProfile = (
  userProfileBrand: any,
  userProfileCampus: any,
  userProfileInstitution: any,
) => {
  const brandSettings = userProfileBrand?.brandSettingsDTO?.brandAISettingsDTO;
  const campusSettings =
    userProfileCampus?.campusSettingsDTO?.campusAISettingsDTO;
  const instSettings =
    userProfileInstitution?.institutionSettingsDTO?.institutionAISettingsDTO;

  const resolve = (field: string) =>
    instSettings?.[field] ?? campusSettings?.[field] ?? brandSettings?.[field] ?? false;

  return {
    canImportActivity: resolve("canImportActivity"),
    canGenerateActivity: resolve("canGenerateActivity"),
    canEvaluateOpenEnded: resolve("canEvaluateOpenEnded"),
    canSolveActivityTemplate: resolve("canSolveActivityTemplate"),
    canGenerateRubric: resolve("canGenerateRubric"),
    canGenerateLessonPlan: resolve("canGenerateLessonPlan"),
    canGenerateInClassActivity: resolve("canGenerateInClassActivity"),
    canGenerateImage: resolve("canGenerateImage"),
    canGeneratePodcast: resolve("canGeneratePodcast"),
    canUseMascotVoiceChat: resolve("canUseMascotVoiceChat"),
    canDrawChatDiagram: resolve("canDrawChatDiagram"),
  };
};

export const findGeneralSettingsFromCurrentProfile = (
  userProfileBrand: any,
  userProfileCampus: any,
  userProfileInstitution: any,
) => {
  const brandSettings =
    userProfileBrand?.brandSettingsDTO?.brandGeneralSettingsDTO;
  const campusSettings =
    userProfileCampus?.campusSettingsDTO?.campusGeneralSettingsDTO;
  const instSettings =
    userProfileInstitution?.institutionSettingsDTO?.institutionGeneralSettingsDTO;

  return {
    canAutoAssignBranchAssignment:
      instSettings?.canAutoAssignBranchAssignment
        ?? campusSettings?.canAutoAssignBranchAssignment
        ?? brandSettings?.canAutoAssignBranchAssignment ?? false,
    branchAssignmentDelayType:
      instSettings?.branchAssignmentDelayType
        ?? campusSettings?.branchAssignmentDelayType
        ?? brandSettings?.branchAssignmentDelayType ?? "NO_DELAY",
    branchAssignmentActivityCount:
      instSettings?.branchAssignmentActivityCount
        ?? campusSettings?.branchAssignmentActivityCount
        ?? brandSettings?.branchAssignmentActivityCount ?? 5,
    // P6: an institution may hide learner-vs-learner rankings (branch boards stay). Undefined at every
    // level = a backend that predates the switch, which always showed them.
    canShowIndividualRanking:
      instSettings?.canShowIndividualRanking
        ?? campusSettings?.canShowIndividualRanking
        ?? brandSettings?.canShowIndividualRanking ?? true,
  };
};

export const formatPriceWithCommas = (number: number, language: string) => {
  return number.toLocaleString(language, {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  });
};

export const retrieveInstitutionTypeByLevel = (level: number) => {
  if (level < 5) {
    return "EAST_PRIMARY";
  } else if (level < 9) {
    return "EAST_SECONDARY";
  } else if (level < 13) {
    return "HIGH_SCHOOL";
  }
};
